import { render } from "./BuildSimulatorUrl.vue?vue&type=template&id=8bd88c04"
import script from "./BuildSimulatorUrl.vue?vue&type=script&lang=js"
export * from "./BuildSimulatorUrl.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__